






























































































import { Component, Mixins } from "vue-property-decorator";

// Mixins
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { categoriesFilters } from "@/data/filters/provisioning";
import { categoriesSorters } from "@/data/sorters/provisioning";

import { Sorters } from "@/data/table";

// Types
import { ITableConfig, IFilter, ISorter } from "@/models/tables";

@Component
export default class ProvisionBlueprintsTable extends Mixins(
  FilteringSortingTableStore
) {
  public guardFunctionalities = ["list_provision_blueprints"];

  public filters: IFilter[] = categoriesFilters;
  public sorters: ISorter[] = categoriesSorters;

  public loading = false;
  public filter = "";

  public apiProps = {
    with: "blueprint_field_counts"
  };

  public defaults: ITableConfig = {
    limit: 10,
    sort: {
      field: "name",
      direction: Sorters.ASCENDING
    }
  };

  public dataModule: string = DataModules.PROVISIONING_BLUEPRINTS;

  public async created() {
    if (!this.isContentAvailable) {
      return;
    }

    this.loading = true;
    this.getData();
  }

  public refresh() {
    this.getData({ ignoreStored: true });
  }

  public hasBrandFields(category) {
    return (
      this.$_.get(
        this.$_.find(this.$_.get(category, "blueprint_field_counts", []), [
          "type",
          "brand"
        ]),
        "count",
        0
      ) > 0
    );
  }

  public get isContentAvailable() {
    return this.$userCan(...this.guardFunctionalities);
  }
}
